import {
  UPDATE_JOURNAL_TYPES_LIST,
  TOGGLE_JOURNAL_TYPES_LOADING,
  JOURNAL_TYPES_ERROR,
  JOURNAL_TYPES_UPDATE_TOTAL
} from '../actions/journalTypesActions'

const initState = {
  name: 'Journal Types',
  types: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0
  }
}

const journalTypesReducer = (state = initState, action) => {
  switch (action.type) {
    case UPDATE_JOURNAL_TYPES_LIST:
      return { ...state, types: { ...state.types, list: action.payload.value } }
    case JOURNAL_TYPES_UPDATE_TOTAL:
      return { ...state, types: { ...state.types, totalRecords: action.payload.value } }
    case TOGGLE_JOURNAL_TYPES_LOADING:
      return { ...state, types: { ...state.types, loading: action.payload.value } }
    case JOURNAL_TYPES_ERROR:
      return { ...state, types: { ...state.types, error: action.payload.value } }
    default:
      return state
  }
}

export default journalTypesReducer
